import {createSelector} from 'reselect';
import {getTripData} from './store';
import {getBrandId, getHavId, getLocale, getGaiaId} from './system';

const getMesoContext = createSelector(
    [getBrandId, getHavId, getLocale, getGaiaId, getTripData],
    (brandId, havId, locale, gaiaId, details) => {
        return {
            brandId,
            gaiaId,
            havId,
            locale,
            details: {
                adults: details.adults,
                children: details.children,
                arriveDate: details.arriveDateText,
                departDate: details.departDateText
            }
        };
    }
);

export default getMesoContext;
